import { supabase } from "../../../app/supabaseClient";
import supabaseApi from "../supabaseSlice";

const facilitiesApi = supabaseApi.injectEndpoints({
  endpoints: (build) => ({
    getFacilities: build.query({
      queryFn: async () => {
        const { data, error } = await supabase
          .from("facilities")
          .select("*")
          .order("order");
        if (error) throw { error };
        return { data };
      },
    }),
  }),
});

export const { useGetFacilitiesQuery, useLazyGetFacilitiesQuery } =
  facilitiesApi;
